import React, { useState } from "react";
import { IRCASettings } from "entities/RCA/RCASettingsEntity/RCASettingsEntityInterfaces";
import { RCASettingsContext } from "./RCASettingsContext";
import { IRCASettingsContextProps } from "./RCASettingsContextInterfaces";

export const RCASettingsContextProvider: React.FC<IRCASettingsContextProps> = ({ children }) => {
    const [rcaSettingsChanges, setRcaSettingsChanges] = useState<IRCASettings[]>([]);
    const providerValue = {
        setRcaSettingsChanges,
        rcaSettingsChanges,
    };

    return <RCASettingsContext.Provider value={providerValue}>{children}</RCASettingsContext.Provider>;
};
